import { render, staticRenderFns } from "./PatientDetailsSummary.vue?vue&type=template&id=025240be"
import script from "./PatientDetailsSummary.vue?vue&type=script&lang=js"
export * from "./PatientDetailsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports